/**
 * Zip widgets — park/restore the drawer node across cart HTML swaps so the
 * checkout bar doesn't jump when the SDK remounts.
 */
(() => {
  let parkedDrawerZip = null;

  function dollarsFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return null;
    return (n / 100).toFixed(2);
  }

  function renderZip() {
    if (window.$zmJs && typeof window.$zmJs.render === 'function') {
      try {
        window.$zmJs.render();
      } catch (_) {}
    }
  }

  function ensureDrawerHost() {
    return document.querySelector('#CartDrawer-ZipHost');
  }

  function buildDrawerZip(priceDollars) {
    const merchant =
      document.querySelector('[data-zm-merchant]')?.getAttribute('data-zm-merchant') ||
      parkedDrawerZip?.getAttribute('data-zm-merchant');
    if (!merchant) return null;

    const el = document.createElement('div');
    el.id = 'zip-widget-drawer';
    el.className = 'zip-widget zip-widget--drawer';
    el.setAttribute('data-zip-widget', 'drawer');
    el.setAttribute('data-zm-widget', 'popup');
    el.setAttribute('data-zm-region', 'au');
    el.setAttribute('data-env', 'production');
    el.setAttribute('data-zm-merchant', merchant);
    el.setAttribute('data-zm-price', priceDollars || '0');
    el.setAttribute('data-zm-asset', 'productwidget');
    el.setAttribute('data-zm-popup-asset', 'termsdialog');
    return el;
  }

  /** Detach drawer Zip before section HTML wipe. */
  window.__d1ZipPark = function () {
    const el = document.querySelector('[data-zip-widget="drawer"]');
    if (!el) return;
    parkedDrawerZip = el;
    el.remove();
  };

  /** Re-attach parked Zip into the reserved host; update price; re-render. */
  window.__d1ZipRestore = function (cents) {
    const host = ensureDrawerHost();
    if (!host) return;

    const emptyCart = document.querySelector('cart-drawer')?.classList.contains('is-empty');
    const price = dollarsFromCents(cents);
    const hide = emptyCart || cents === 0 || cents === '0';

    host.hidden = !!hide;
    if (hide) return;

    let el = host.querySelector('[data-zip-widget="drawer"]');
    if (!el && parkedDrawerZip) {
      el = parkedDrawerZip;
      host.innerHTML = '';
      host.appendChild(el);
    }
    if (!el) {
      el = buildDrawerZip(price || '0');
      if (!el) return;
      host.innerHTML = '';
      host.appendChild(el);
      parkedDrawerZip = el;
    }

    if (price != null && el.getAttribute('data-zm-price') !== price) {
      el.setAttribute('data-zm-price', price);
    }

    renderZip();
  };

  function updateProductWidgets(cents) {
    const price = dollarsFromCents(cents);
    if (price == null) return;
    document.querySelectorAll('[data-zip-widget="product"]').forEach((el) => {
      if (el.getAttribute('data-zm-price') !== price) el.setAttribute('data-zm-price', price);
    });
    renderZip();
  }

  window.__d1ZipRefresh = function (cents) {
    if (cents != null) window.__d1ZipRestore(cents);
    else {
      const el = document.querySelector('[data-zip-widget="drawer"]');
      const current = el && el.getAttribute('data-zm-price');
      window.__d1ZipRestore(current != null ? Math.round(Number(current) * 100) : undefined);
    }
  };

  function bindUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (variant && variant.price != null) updateProductWidgets(variant.price);
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const data = event?.cartData || event?.data?.cartData;
      if (data && data.total_price != null) window.__d1ZipRestore(data.total_price);
      else renderZip();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindUpdates, { once: true });
  } else {
    bindUpdates();
  }
})();
